import { httpClient } from 'Shared/network';
import type { GetPointCalenderResponse } from 'viewup-api/v2';

export interface GetCalenderReq {
  monthValue: number;
  yearValue: number;
}

export const getCalender = async ({
  monthValue,
  yearValue,
}: GetCalenderReq): Promise<GetPointCalenderResponse> => {
  const { data } = await httpClient.get<GetPointCalenderResponse>('/v2/point/calender', {
    params: {
      month: monthValue,
      year: yearValue,
    },
  });

  return data;
};
